import { render, staticRenderFns } from "./InformationsStep.vue?vue&type=template&id=6ed63ca2&"
import script from "./InformationsStep.vue?vue&type=script&lang=js&"
export * from "./InformationsStep.vue?vue&type=script&lang=js&"
import style0 from "./InformationsStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports